<script>
  import { 
    Row, Column, Block, Text, Icon, Switch, NumberInput,
    TextInput, FileInput, Toast, Image, Select, CheckBox, Group
  } from 'bastone'
  import { colors, fileBaseUrl } from '../consts'
  import Page from '../components/page.svelte'
  import Header from '../components/header.svelte'
  import MyButton from '../components/button.svelte'
  import Confirm from '../components/confirm.svelte'
  import UploadBox from '../components/uploadbox.svelte'
  import { ApiClient, ChatBot } from '../models'
  import { notify, currentUser, Context, isDesktop } from '../context'
  import { upload, getByteLength } from '../utils'
  import { onMount } from 'svelte'
  import { meta } from 'tinro'

  const routeMeta = meta()

  let bot = new ChatBot({
    name: '',
    desc: '',
    category: '',
    type: 0,
    prompt: '',
    prompt_vars: [],
    welcome: '',
    avatar_url: '',
    is_public: undefined,
    is_official: false,
    is_audited: false,
    file_name: '',
    file_url: '',
    manager_name: '',
  })

  let publicItems = [
    {name: '公开', value: true},
    {name: '私人', value: false},
  ]

  let categoryItems = [
    {name: '日常工具', value: 'tool'},
    {name: '生活娱乐', value: 'fun'},
    {name: '编程代码', value: 'code'},
    {name: '学术科研', value: 'science'},
    {name: '材料写作', value: 'write'},
    {name: '其他', value: 'other'},
  ]

  let promptVarTypes = [
    {name: '文本', value: 'text'},
    {name: '长文本', value: 'longtext'},
    {name: '选项', value: 'option'},
  ]

  let dataFileName = ''
  let avatarInput = null
  let uploadToken = null
  let useDataSet = false
  let errorMessage = ''
  let editing = false
  let confirm = null
  let uploadShowing = false
  let nameFocusing = false

  
  async function uploadAvatar() {
    if (avatarInput.files.length < 1) {
      return
    }
    
    if (uploadToken === null) {
      notify('获取上传token失败')
      return
    }

    let file = avatarInput.files[0]
    if (file.size > 5 * 1024 * 1024) {
      errorMessage = '文件大小不能超过5MB'
      return
    }

    let key = `images/${Date.now()}_${$currentUser.id}`
    upload(file, key, uploadToken, ()=>{
      bot.avatar_url = fileBaseUrl + key + '-avatar'
    })

  }

  function uploadDone(file, fileUrl) {
    dataFileName = `${file.name}(${(file.size/1048576).toFixed(2)}MB)`
    bot.file_name = file.name
    bot.file_url = fileUrl
    uploadShowing = false
  }

  async function upsertBot() {
    if (!bot.name || !bot.desc ) {
      errorMessage = '请输入BOT名称和描述'
      return 
    }

    if (getByteLength(bot.name.length) > 12) {
      errorMessage = '名称长度超限'
      return
    }

    if (getByteLength(bot.prompt.length) > 2048) {
      errorMessage = 'Prompt长度超限'
      return
    }

    for (let i = 0; i <  bot.prompt_vars.length; i++) {
      let prompt_var = bot.prompt_vars[i]
      if (!prompt_var.name || !prompt_var.title ||
        (prompt_var.type == 'option' && !prompt_var.values)) {
        errorMessage = `变量${prompt_var.name}缺少选项值`
        return 
      }

      if (!bot.prompt.includes('{'+prompt_var.name+'}')) {
        errorMessage = 'Prompt中必须包含变量名' + prompt_var.name
        return 
      }

      if (prompt_var.type == 'option') {
        prompt_var.values = prompt_var.values.replaceAll('，', ',')
        prompt_var.default = prompt_var.values.split(',')[0]
      }
    }

    if (!useDataSet) {
      bot.file_name = ''
      bot.file_url = ''
    }
    if (editing) bot.setValue('prompt_vars', bot.prompt_vars)
    let ok = editing ? await bot.update() : await bot.create()
    if (!ok) {
      errorMessage = editing ? '保存失败' : '创建失败'
    } else {
      location.href = '/chat?bot_id=' + bot.id
    }
  }

  function addPromptVar() {
    if (bot.prompt_vars.length >= 10) {
      errorMessage = '最多添加10个变量'
      return 
    }
    bot.prompt_vars.push({
      key: new Date().getTime(), 
      name: '', 
      title: '', 
      type: '', 
      default: '',
      values: '',
    })
    bot = bot
  }
  
  function deleteBot() {
    confirm.show(`确定要删除${bot.name}吗?`, ()=>{
      bot.delete().then(ok=>{
        if (ok) location.href='/chat'
      })
    })
  }

  onMount(async () => {
    let urlPath = window.location.pathname
    if (urlPath.toLowerCase().startsWith('/editbot')) {
      let id = routeMeta.params.id
      bot = await ChatBot.getOne(id)
      if (!bot) {
        notify('未找到对应的BOT')
      }
      if (!$currentUser) {
        await Context.init()
      }
      if (bot.user_id != $currentUser.id) {
        notify('只能编辑自己的BOT')
      }
      editing = true
    }

    ApiClient.getUploadToken().then((token) => {
      uploadToken = token
    })

    notify('严禁提交违法/敏感内容或图片，违者上报公安部ICRC处理', 'warning', 3000)
  })

</script>

<UploadBox bind:showing={uploadShowing} {uploadDone}/>
<Confirm bind:this={confirm}/>
<Page title={editing?'修改BOT配置项':'创建自己的专属BOT'}>
  <Header buttonType='back'/>
  <Block minHeight=1.5rem/>
  <Row align=center>
    <Column>
      <Text size=1.6rem bold=1>{editing?'修改BOT配置项':'创建BOT机器人'}</Text>
      <Block height=1.5rem/>
      <Group direction={$isDesktop?'row':'column'}>
        <Column>
          <Text size=1rem>头像/名称</Text>
          <Block height=0.5rem/>
          <Row>
            <FileInput bind:input={avatarInput} accept=".jpg,.jpeg,.png" on:change={uploadAvatar}>
              <Block 
                borderColor={nameFocusing?'black':'darkgray'} height=2.2rem width=2.2rem border=1 rightBorder=0
                position=relative
              >
                <Row align=center height=100% width=100%>
                  {#if bot.avatar_url}
                  <Image height=2rem url={bot.avatar_url}/>
                  {:else}
                  <Image height=1.5rem url='/images/upimage.png'/>
                  {/if}
                </Row>
              </Block>
            </FileInput>
            <TextInput 
              bind:focusing={nameFocusing} width={$isDesktop?'17.8rem':'18.8rem'} height=2.2rem 
              placeholder=BOT名称,最多6个字 bind:value={bot.name}
            />
          </Row>
          
        </Column>
        <Block width=1rem height=1rem/>
        <Column>
          <Text size=1rem>所属类别</Text>
          <Block height=0.5rem/>
          <Select 
            width={$isDesktop?'20rem':'21rem'} height=2.2rem fontSize=1rem placeholder=类型 border=1 
            items={categoryItems} bind:currentValue={bot.category}
          ></Select>
        </Column>
      </Group>

      <Block height=1rem/>

      <Group direction={$isDesktop?'row':'column'}>
        <Column>
          <Text size=1rem>描述</Text>
          <Block height=0.5rem/>
          <TextInput width={$isDesktop?'20rem':'21rem'} height=2.2rem
            placeholder=一句话介绍你的聊天机器人
            bind:value={bot.desc}
          ></TextInput>
        </Column>
        <Block width=1rem height=1rem/>
        <Column>
          <Row>
            <Text size=1rem>公开/私人</Text>
            <Block width=0.2rem/>
            <Toast top=1.2rem left=-4rem>
              <Icon slot=target name=help size=1.1rem></Icon>
              <Block slot=toast backgroundColor={colors.translucent} padding=0.4rem width=11rem>
                <Text color=white size=0.8rem wrap=1>
                  公开后将在BOT广场展示，热门BOT将获得点数奖励
                </Text>
              </Block>
            </Toast>
          </Row>
          <Block height=0.5rem/>
          <Select 
            width={$isDesktop?'20rem':'21rem'} height=2.2rem fontSize=1rem placeholder=类型 border=1 
            items={publicItems} bind:currentValue={bot.is_public}
          ></Select>
        </Column>
      </Group>
      <Block height=1rem/>

      <Column>
        <Text size=1rem>欢迎语</Text>
        <Block height=0.5rem/>
        <TextInput 
          width={$isDesktop?'41rem':'21rem'} height=5rem placeholder=新建对话时自动发送，选填
          bind:value={bot.welcome} resize=vertical multiline=1
        ></TextInput>
      </Column>
      <Block height=1rem/>

      <Column>
        <Row>
          <Text size=1rem>System Prompt</Text>
          <Block width=0.3rem/>
          <Toast top=1.2rem left=-7rem>
            <Icon slot=target name=help size=1.1rem></Icon>
            <Block slot=toast backgroundColor={colors.translucent} padding=0.4rem width=13rem>
              <Text color=white size=0.8rem wrap=1>
                变量在对话页面让用户填写，然后以Prompt为模板进行填充形成完整的Prompt发送，确保变量名以{'{var_name}'}形式存在于Prompt中
              </Text>
            </Block>
          </Toast>
          <Block width=0.5rem/>
          <MyButton 
            border=1 height=1.6rem width=4.6rem bold={false} 
            borderColor={colors.black} fontSize=0.8rem
            on:click={addPromptVar}
          >+添加变量</MyButton>
        </Row>
        
        <Block height=0.7rem/>
        <TextInput width={$isDesktop?'41rem':'21rem'} multiline=1 height=6rem resize=vertical border=1
          placeholder=系统提示词，用于设定BOT的身份角色、语言风格、必要背景知识等。变量以{'{var_name}'}形式填写，变量会出现在对话界面让用户设定，不超过1000字
          bind:value={bot.prompt}
        ></TextInput>
      </Column>

      {#each bot.prompt_vars as prompt_var, i (prompt_var.key)}
      <Block height=0.7rem/>
      <Text size=1rem>第{i+1}个变量</Text>
      <Block height=0.5rem/>
      <Group direction={$isDesktop?'row':'column'}>
        <Row>
          <TextInput 
            width=6.5rem height=2rem fontSize=0.9rem placeholder=变量名(英文)
            bind:value={prompt_var.name}
          ></TextInput>
          <Block width=0.5rem/>
          <TextInput 
            width=8.5rem height=2rem fontSize=0.9rem placeholder=对用户显示的名称
            bind:value={prompt_var.title}
          ></TextInput>
          <Block width=0.5rem/>
          <Select 
            border=1 width=5rem height=2rem fontSize=0.9rem placeholder=类型 
            items={promptVarTypes} bind:currentValue={prompt_var.type}
          ></Select>
        </Row>
        <Block width=0.5rem height=0.5rem/>
        <Row>
          {#if prompt_var.type != 'option'}
          <TextInput 
            width={$isDesktop?'15rem':'16.5rem'} height=2rem fontSize=0.9rem placeholder=默认值,可不填
            bind:value={prompt_var.default}
          ></TextInput>
          <Block width=0.5rem/>
          {:else}
          <TextInput 
            width={$isDesktop?'15rem':'16.5rem'} height=2rem fontSize=0.9rem placeholder=选项值,逗号分隔,例如:aa,bb,cc
            bind:value={prompt_var.values}
          ></TextInput>
          <Block width=0.5rem/>
          {/if}
          <MyButton 
            border=1 height=2rem width=4rem bold={false} borderColor=darkgray
            icon=ashbin iconSize=1rem space=0.3rem
            on:click={()=>{bot.prompt_vars.splice(i,1);bot=bot}}
          >删除</MyButton>
        </Row>
      </Group>
      {/each}
      <Block height=1rem/>

      {#if !editing}
      <Block height=0.5rem/>
      <Row>
        <Text size=1rem bold=1>启用数据集</Text>
        <Block width=0.2rem/>
        <Toast top=1.2rem left=-6rem>
          <Icon slot=target name=help size=1.1rem bold=1></Icon>
          <Block slot=toast backgroundColor={colors.translucent} padding=0.4rem width=14rem>
            <Text color=white size=0.8rem wrap=1>
              启用后可上传私有数据集/知识库，使BOT具备专业领域对话能力，仅PRO会员可用
            </Text>
          </Block>
        </Toast>
        <Block width=0.6rem/>
        <Switch
          on:change={ 
            e => {
              let on = e.detail.on;
              if ($currentUser?.is_pro) {
                useDataSet = on
              } else {
                notify('数据集功能仅PRO会员可用', 'warning')
              }
            }
          }
        ></Switch>
      </Row>

      {#if useDataSet && $currentUser?.is_pro}
      <Block height=0.5rem/>
      <Row>
        <MyButton 
          border=1 height=2.2rem width=6.6rem bold={false} borderColor=darkgray
          icon=attachment iconSize=1rem space=0.3rem rightBorder=0 fontSize=0.9rem
          on:click={()=>uploadShowing=true}
        >上传文件</MyButton>
        <Block 
          width={$isDesktop?'34.4rem':'14.4rem'}  height=2.2rem padding=0.4rem borderColor=darkgray border=1
          on:click={()=>uploadShowing=true}
        >{dataFileName}</Block>
      </Row>
      {/if}

      <Block height=1rem/>
      {/if}
      
      {#if $currentUser?.is_admin}
      <Text size=1rem bold=1>管理员选项</Text>
      <Block height=0.8rem/>
      <Row>
        <CheckBox 
          iconColor={colors.black} size=1rem border=2 borderColor={colors.lightGray} space=0.4rem
          bind:checked={bot.is_official}
        >官方</CheckBox>
        <Block width=1rem/>
        <CheckBox 
          iconColor={colors.black} size=1rem border=2 borderColor={colors.lightGray} space=0.4rem
          bind:checked={bot.is_audited}
        >已审核</CheckBox>
        <Block width=1rem/>
        <Text>Manager</Text>
        <Block width=0.4rem/>
        <TextInput width=6rem bind:value={bot.manager_name}/>
      </Row>
      <Block height=1rem/>
      {/if}
      
      

      <!--
      <Block border=1 width={$isDesktop?'41rem':'21rem'} padding=0.4rem borderColor={colors.black} backgroundColor={colors.snow}>
        <Row>
          <Block width=0.2rem/>
          <Icon name=warning size=1.2rem bold=1/>
          <Block width=0.5rem/>
          <Text wrap=1>私有数据集功能正在内测中，节后上线，您可以先创建上线后再启用</Text>
        </Row>
      </Block>
      <Block height=1rem/>
      -->

      {#if errorMessage}
      <Text color={colors.red} width={$isDesktop?'41rem':'21rem'} wrap=1>{errorMessage}</Text>
      <Block height=1rem/>
      {/if}

      <Block height=0.5rem/>
      <Row>
        {#if !editing}
        <MyButton
          fill=1 width=7rem height=2.2rem fontSize=1rem
          on:click={upsertBot}
        >
          {#if !$currentUser?.is_pro || true}
          <Image width=0.9rem url='/images/coinw.png'/>
          <Block width=0.2rem/>
          {/if}
          <Text lineHeight=2rem>100&nbsp;创建</Text>
        </MyButton>
        {:else}
        <MyButton
          fill=1 width=6rem height=2.2rem fontSize=1rem
          on:click={upsertBot}
        >保存</MyButton>
        {/if}
        
        <Block width=1.5rem/>
        <MyButton 
          on:click={()=>location.href=editing?'/chat':'/home'} 
          width=6rem height=2.2rem fontSize=1rem
        >取消</MyButton>

        {#if editing}
        <Block width=1.5rem/>
        <MyButton 
          width=6rem height=2.2rem fontSize=1rem
          on:click={deleteBot}
        >删除BOT</MyButton>
        {/if}
      </Row>
      <Block height=2rem/>

    </Column>
  </Row>
</Page>


